var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 9.99984C18.3307 14.5998 14.5974 18.3332 9.9974 18.3332C5.3974 18.3332 2.58906 13.6998 2.58906 13.6998M2.58906 13.6998H6.35573M2.58906 13.6998V17.8665M1.66406 9.99984C1.66406 5.39984 5.36406 1.6665 9.9974 1.6665C15.5557 1.6665 18.3307 6.29984 18.3307 6.29984M18.3307 6.29984V2.13317M18.3307 6.29984H14.6307",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a6111d76588de3ef7e23429989cd589c.svg";
export { ForwardRef as ReactComponent };